import { render } from "./Worldapp.vue?vue&type=template&id=886b393a"
import script from "./Worldapp.vue?vue&type=script&lang=js"
export * from "./Worldapp.vue?vue&type=script&lang=js"
script.render = render

export default script